import "./App.css";
import React, { useState, useEffect } from "react";
import AppRoutes from "./Routes/Routes";
import { CartProvider } from "./contexts/CartContext";
import WelcomeScreen from "./Component/WelcomeScreen";

function App() {
  const [showWelcome, setShowWelcome] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowWelcome(false);
    }, 5000); // 5 seconds
    return () => clearTimeout(timer);
  }, []);

  return (
    <CartProvider>
      <div>
        {showWelcome && <WelcomeScreen onFinish={() => setShowWelcome(false)} />}
        {/* Home and other pages load in the background */}
        <div style={{ filter: showWelcome ? "blur(3px)" : "none" }}>
          <AppRoutes />
        </div>
      </div>
    </CartProvider>
  );
}

export default App;
